<script>
  /* Executable code section of the program */
  //Tools importation
  import {
    isPreviewEventPageModal,
    temporalData,
    invitedAttendeesArray,
    alertMessagge,
    isAlertOn,
    isConfirmModalOn,
    confirmResponse,
    isReloadNecessary
  } from "../../apis/storage";
  import {
    idGenerator,
    deleteCustomElements,
    updateOneDocument,
    updateMultipleDocuments,
    addAndDeleteMultipleDocuments,
  } from "../../apis/APIS";
  import SelectAttendees from "../SelectAttendees.svelte";
  import { element } from "svelte/internal";
  import ConfirmModal from "./ConfirmModal.svelte";

  //Auxiliary Variables
  /* */
  let eventWallpaperUrl =
      $temporalData.eventMultimedia.eventWallpaperUrl
  let eventPoster =
    $temporalData.eventMultimedia.eventImgUrl 
  /*   let eventButtons = [
    { buttonTittle: "Polls", isAvailable: true },
    { buttonTittle: "Meetings", isAvailable: false },
    { buttonTittle: "Mails", isAvailable: true },
  ];
 */
  let eventButtons = $temporalData.eventButtons;
  $: dinamicEventButtons = eventButtons;
  let isButtonCreation = false;
  let isSelectDisplay = false;
  let objData = {};
  let deleteArray = [];
  let customAttendeesButton = [];
  let deleteAttendeesButton = [];
  let temporalAttendees = [];
  let buttonSelected = {}
  let isUpdating = false;

  //Required variables
  objData.buttonTittle = "";
  objData.buttonUrl = "";

  //Function to undisplay modal
  const undisplayModal = () => {
    $isPreviewEventPageModal = false;
  };

  //Display button creation form
  const formCreationButton = () => {
    isButtonCreation = true;
    isSelectDisplay = true;
  };

  //Undisplay button creation form
  const closeCreationButton = () => {
    isButtonCreation = false;
    isUpdating = false;
    objData = {};
    $invitedAttendeesArray = [];
    customAttendeesButton = [];
    deleteAttendeesButton = [];
  };
  //function to display alert
  const displayAlert = () => {
    $isAlertOn = true;
  };

  // Funtion to creat and save button and changes
  const createButton = () => {
    if (objData.buttonUrl === "" || objData.buttonTittle === "") {
      $alertMessagge = "Button name and URL cannot be empty"
      displayAlert();
    } else {
      objData.isAvailable = false;
      objData.id = idGenerator();
      objData.isAssignedButton = false;
      if ($invitedAttendeesArray.length > 0) {
        objData.isAssignedButton = true;
        objData.assignedAttendees = $invitedAttendeesArray;
      }
      saveButtonChanges();
      $invitedAttendeesArray = [];
    }
  };

  const saveButtonChanges = () => {
    if ($invitedAttendeesArray.length > 0) {
      $invitedAttendeesArray.forEach((element) => {
        customAttendeesButton.push({
          id: element.id,
          fieldName: "customButtons",
          values: [objData.id],
        });
      });
      //Function to update database and save changes
      updateMultipleDocuments("users", customAttendeesButton)
        .then(() => {
          eventButtons.push(objData);
          $temporalData.eventButtons = eventButtons;
          updateOneDocument("events", $temporalData, $temporalData.id)
            .then(() => {
              $alertMessagge = "Button created successfully.";
              $isReloadNecessary = true
              displayAlert();
              dinamicEventButtons = eventButtons;
              objData = {};
              isButtonCreation = false;
              customAttendeesButton = [];
              deleteAttendeesButton = [];
            })
            .catch(() => {
              $alertMessagge = "An error occurred while creating the button";
              displayAlert();
            });
        })
        .catch(() => {
              $alertMessagge = "Could not create the button, please try again.";
              displayAlert();
        });
    } else {
      eventButtons.push(objData);
      $temporalData.eventButtons = eventButtons;
      updateOneDocument("events", $temporalData, $temporalData.id).then(() => {
              $alertMessagge = "Button created successfully.";
              $isReloadNecessary = true
              displayAlert();
              dinamicEventButtons = eventButtons;
              objData = {};
              isButtonCreation = false;
            })
            .catch(() => {
              $alertMessagge = "An error occurred while creating the button";
              displayAlert();
            });
    }
  };

  //Function to save buttons changes
  const saveChanges = () => {
    updateOneDocument("events", $temporalData, $temporalData.id)
    .then(() => {
              $alertMessagge = "Changes were saved successfully.";
              displayAlert();
            })
  };

  //Funciton to update a button
  const editButton = (data) => {
    isButtonCreation = true;
    isSelectDisplay = true;
    isUpdating = true;
    objData = data;
    if (data.isAssignedButton) {
      isSelectDisplay = true;
      $invitedAttendeesArray = data.assignedAttendees;
      temporalAttendees = data.assignedAttendees;
    }
  };
  const updateButton = () => {
    if ($invitedAttendeesArray.length > 0) {
      objData.isAssignedButton = true;
      temporalAttendees = temporalAttendees.concat($invitedAttendeesArray);

      // Management of assigned attendees
      temporalAttendees.forEach((element) => {
        // Check if the element exists in $invitedAttendeesArray
        const existsInInvited = $invitedAttendeesArray.some(
          (attendee) => attendee.id === element.id
        );

        if (existsInInvited) {
          customAttendeesButton.push({
            id: element.id,
            fieldName: "customButtons",
            values: [objData.id],
          });
        } else {
          deleteAttendeesButton.push({
            id: element.id,
            fieldName: "customButtons",
            values: [objData.id],
          });
        }
      });

      //Section for database update implementation.
      addAndDeleteMultipleDocuments(
        "users",
        deleteAttendeesButton,
        customAttendeesButton
      ).then(() => {
        objData.assignedAttendees = $invitedAttendeesArray;
        $temporalData.eventButtons = eventButtons;
        updateOneDocument("events", $temporalData, $temporalData.id).then(() => {
              $alertMessagge = "Button updated successfully.";
              $isReloadNecessary = true
              displayAlert();
            })
            .catch(() => {
              $alertMessagge = "An error occurred while updating the button";
              displayAlert();
            });
        dinamicEventButtons = eventButtons;
        $invitedAttendeesArray = [];
        objData = {};
        customAttendeesButton = [];
        deleteAttendeesButton = [];
        isButtonCreation = false;
        isUpdating = false;
      });
    } else {
      objData.isAssignedButton = false;
      objData.assignedAttendees = [];
      $temporalData.eventButtons = eventButtons;
      updateOneDocument("events", $temporalData, $temporalData.id).then(() => {
              $alertMessagge = "Button updated successfully.";
              $isReloadNecessary = true
              displayAlert();
            })
            .catch(() => {
              $alertMessagge = "An error occurred while updating the button";
              displayAlert();
            });
    }
  };

  //Function to display confirm modal
  const displayConfirmModal = (data) =>{
    buttonSelected = data
    $isConfirmModalOn = true
    $alertMessagge = "Are you sure you want to delete this button?"
  }

  //Function to delete a button
  const deleteButton = (data) => {
    if ($confirmResponse) {
      eventButtons = eventButtons.filter((button) => button.id !== buttonSelected.id);
      $temporalData.eventButtons = eventButtons;
      updateOneDocument("events", $temporalData, $temporalData.id).then(() => {
        $alertMessagge = "Button deleted successfully.";
        displayAlert();
        if (buttonSelected.assignedAttendees.length > 0) {
          buttonSelected.assignedAttendees.forEach((element) => {
            deleteArray.push({
              id: element.id,
              fieldName: "eventButtons",
              values: [buttonSelected.id],
            });
          });
          deleteCustomElements("users", deleteArray);
        }
      })
      .catch(() => {
        $alertMessagge = "An error occurred while deleting the button";
        displayAlert();
      });
    }
  };

  //Function to delete a button

  /* End of the section */
</script>

<!-- Section to place the HTML code -->
<section class="principalContainer">
  <div class="contentContainer">
    <div class="headerContent">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="currentColor"
        class="bi bi-x-circle icon"
        viewBox="0 0 16 16"
        on:keypress={() => undisplayModal()}
        on:click={() => undisplayModal()}
      >
        <path
          d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"
        />
        <path
          d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"
        />
      </svg>
    </div>
    <div class="bodyContent">
      <div
        class="headerBody"
        style="--event-wallpaper:{eventWallpaperUrl}; background-image: url({eventWallpaperUrl})"
      >
        <div class="eventPoster">
          <img src={eventPoster} alt="Event Poster" />
        </div>
        <div class="pageButton">
          <a
            href="/event/{$temporalData.id}/{$temporalData.tittle.replace(
              /\s+/g,
              '-'
            )} "
          >
            <button class="actionBtn addEventBtn">Go Event Page</button>
          </a>
        </div>
      </div>
      <div class="buttonsContainer">
        <div class="tittleContainer">
          <h1>Buttons Section</h1>
          <button class="actionBtn addEventBtn" on:click={formCreationButton}
            >New Button</button
          >
        </div>
        <div class="buttonsSection">
          <div class="generalContainer">
            <div class="infoContainer">
              <p class="buttonTittle"><b>Active Chat:</b></p>
              <label class="switch">
                <input type="checkbox" bind:checked={$temporalData.activeChat} />
                <span class="slider"></span>
              </label>
            </div>
          </div>
          {#each dinamicEventButtons as button}
            <div class="generalContainer">
              <div class="infoContainer">
                <p class="buttonTittle"><b>{button.buttonTittle}:</b></p>
                <label class="switch">
                  <input type="checkbox" bind:checked={button.isAvailable} />
                  <span class="slider"></span>
                </label>
              </div>
              <div class="actionButtonsContainer">
                {#if button.buttonTittle == "Meetings" || button.buttonTittle === "Meets" || button.buttonTittle=== "Attendees" || button.buttonTittle === "Polls"}
                <button
                  class="cardButton addEventBtn"
                  disabled
                  on:click={editButton(button)}
                  ><svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-pencil-square"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"
                    />
                    <path
                      fill-rule="evenodd"
                      d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
                    />
                  </svg></button
                >
                <button
                  class="cardButton addEventBtn"
                  disabled
                  on:click={() => displayConfirmModal(button)}
                  ><svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-trash"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"
                    />
                    <path
                      d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"
                    />
                  </svg></button
                >
                  {:else}
                  <button
                    class="cardButton addEventBtn"
                    on:click={editButton(button)}
                    ><svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-pencil-square"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"
                      />
                      <path
                        fill-rule="evenodd"
                        d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
                      />
                    </svg></button
                  >
                  <button
                    class="cardButton addEventBtn"
                    on:click={() => displayConfirmModal(button)}
                    ><svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-trash"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"
                      />
                      <path
                        d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"
                      />
                    </svg></button
                  >
                {/if}
              </div>
            </div>
          {/each}
        </div>
        {#if isButtonCreation}
          <div class="formButton">
            <div class="form-floating">
              <input
                type="text"
                class="form-control formInput"
                placeholder="Tittle Event"
                bind:value={objData.buttonTittle}
              />
              <label for="floatin gPassword">Button Tittle</label>
              <br />
            </div>
            <div class="form-floating">
              <input
                type="text"
                class="form-control formInput"
                placeholder="Tittle Event"
                bind:value={objData.buttonUrl}
              />
              <label for="floatingPassword">Information URL</label>
              <br />
            </div>
          </div>
          {#if isSelectDisplay}
            <SelectAttendees eventUser={$temporalData.tittle} />
          {/if}
        {/if}
        <div class="buttonsFooter">
          {#if isButtonCreation}
            {#if isSelectDisplay}
              <button
                class="actionBtn addEventBtn"
                on:click={closeCreationButton}>Close Form</button
              >
              {#if isUpdating}
                <button class="actionBtn addEventBtn" on:click={updateButton}
                  >Update Button</button
                >
              {:else}
                <button class="actionBtn addEventBtn" on:click={createButton}
                  >Create Button</button
                >
              {/if}
            {:else}
              <button
                class="actionBtn addEventBtn"
                on:click={closeCreationButton}>Close Form</button
              >
              {#if isUpdating}
                <button class="actionBtn addEventBtn" on:click={updateButton}
                  >Update Button</button
                >
              {:else}
                <!-- <button class="actionBtn addEventBtn" on:click={createButton}
                  >Create Button</button
                > -->
                <button class="actionBtn addEventBtn" on:click={createButton}
                  >Create Button</button
                >
              {/if}
            {/if}
          {:else}
            <button class="actionBtn addEventBtn" on:click={saveChanges}
              >Save Button</button
            >
          {/if}
        </div>
      </div>
    </div>
    <div class="footerContent">
      <a
        href="/event/{$temporalData.id}/{$temporalData.tittle.replace(
          /\s+/g,
          '-'
        )} "
      >
        <button class="actionBtn addEventBtn">Go Event Page</button>
      </a>
    </div>
  </div>
</section>
{#if $isConfirmModalOn}
  <ConfirmModal callbackFunction = {deleteButton}/>
{/if}

<!-- End of the section -->
<style>
  /* Section to place the code styles */
  /* Principal styles */
  .principalContainer {
    width: 100%;
    height: 100dvh;
    padding: 30px;
    display: flex;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.432);
    position: fixed;
    top: 0;
    z-index: 888;
  }
  .contentContainer {
    width: 80%;
    height: auto;
    max-height: 90vh;
    overflow: auto;
    background-color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  /* Header content styles */
  .headerContent {
    width: 90%;
    padding: 10px;
    display: flex;
    padding: 30px 30px;
    justify-content: flex-end;
  }
  .icon {
    color: red;
  }
  .icon:hover {
    cursor: pointer;
  }

  /* Body styles */
  .bodyContent {
    width: 90%;
  }
  /* Header */
  .headerBody {
    width: 100%;
    height: 100px;
    padding: 30px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    height: auto;
    display: flex;
    flex-direction: row;
  }
  .eventPoster {
    width: 50%;
    height: auto;
    display: flex;
    justify-content: center;
  }
  img {
    width: 90%;
    height: auto;
  }
  /* Page Button */
  .pageButton {
    width: 60%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.425);
  }
  /* Buttons */
  .tittleContainer {
    width: 100%;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid gray;
    padding: 5px 0;
  }
  h1 {
    padding: 10px;
  }
  .buttonsSection {
    display: flex;
    flex-wrap: wrap;
    padding: 20px;
  }
  .generalContainer {
    width: 20%;
    margin: 10px;
    background-color: #f4f4f4;
    padding: 10px 5px;
  }
  .infoContainer {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0 15px;
  }
  .buttonTittle {
    width: 70%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  /* Edit & Delete buttons styles */
  .actionButtonsContainer {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .cardButton {
    width: 100px;
    height: auto;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 500;
    padding: 5px 16px;
    background-color: white;
    color: #111;
    border: 1px solid #444;
    transition: all 0.3s ease-in-out;
    margin: 5px;
  }

  .buttonsFooter {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    padding: 20px;
    border-bottom: 1px solid gray;
  }
  /* Button form styles */
  .formButton {
    display: flex;
    width: 100%;
    height: auto;
    flex-wrap: wrap;
    padding: 30px;
  }

  /* Buttons styles */

  .actionBtn {
    width: 200px;
    height: auto;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 500;
    padding: 8px 16px;
    background-color: white;
    color: #111;
    border: 1px solid #444;
    transition: all 0.3s ease-in-out;
    margin: 0 20px;
  }

  .addEventBtn:hover {
    cursor: pointer;
    box-shadow: #000 0px 0px 5px;
    transform: scale(1.01);
    border-color: #fff;
    background-color: #ed2824;
    color: White;
  }
  /* Footer content styles */
  .footerContent {
    display: flex;
    justify-content: center;
    width: 90%;
    padding: 20px;
  }
  .form-floating {
    width: 40%;
    margin: 0 10px;
  }

  /* Switch styles  */

  /* From Uiverse.io by gharsh11032000 */
  /* The switch - the box around the slider */
  .switch {
    font-size: 17px;
    position: relative;
    display: inline-block;
    width: 2.8em;
    height: 1.3em;
  }

  /* Hide default HTML checkbox */
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  /* The slider */
  .slider {
    position: absolute;
    cursor: pointer;
    inset: 0;
    background: white;
    border-radius: 50px;
    overflow: hidden;
    transition: all 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 1em;
    width: 1em;
    right: 0.15em;
    bottom: 0.15em;
    transform: translateX(150%);
    background-color: #59d102;
    border-radius: inherit;
    transition: all 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  .slider:after {
    position: absolute;
    content: "";
    height: 1em;
    width: 1em;
    left: 0.15em;
    bottom: 0.15em;
    background-color: #cccccc;
    border-radius: inherit;
    transition: all 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  .switch input:focus + .slider {
    box-shadow: 0 0 1px #59d102;
  }

  .switch input:checked + .slider:before {
    transform: translateY(0);
  }

  .switch input:checked + .slider::after {
    transform: translateX(-150%);
  }

  /* /////////Tablets///////// */
  @media (min-width: 700px) and (max-width: 1100px) {
    .generalContainer {
      width: 45%;
      margin: 10px;
      padding: 10px 5px;
    }
  }
  /* /////////Cellphones ///////// */
  @media (max-width: 700px) {
    /* Header */
    .headerBody {
      flex-direction: column;
    }
    .eventPoster {
      width: 100%;
      height: auto;
      display: flex;
      justify-content: center;
    }
    /* Page Button */
    .pageButton {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 10px 0;
      background-color: rgba(0, 0, 0, 0);
    }
    .generalContainer {
      width: 100%;
      margin: 10px;
      padding: 10px 5px;
    }
    .contentContainer {
      width: 100%;
      height: auto;
      max-height: 90vh;
      overflow: auto;
      background-color: white;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .buttonsFooter {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;
    border-bottom: 1px solid gray;
  }
  .actionBtn {
    margin: 5px;
  }
  .formButton{
    flex-direction: column;
  }
  
  .form-floating {
    width: 90%;
    margin: 5px;
  }
  }

  /* End of the section */
</style>
